import { useLingui } from "@lingui/react/macro";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { subDays } from "date-fns";
import { calendarDateSchema } from "@medoma/models/date-and-time";
import InputField from "@medoma/components/InputField/InputField";
import Form from "@/components/Form/Form";
import {
  DateInput,
  type IDateInputFields,
  type IQuickSelection,
} from "@/forms/AddActivityForm/Scheduling/DateInput";
import { type IShiftPickerFields, ShiftPicker } from "./ShiftPicker";

export type ISchedulingFields = IDateInputFields &
  IShiftPickerFields & {
    time: string;
  };

export const SchedulingFields = () => {
  const { t } = useLingui();
  const {
    register,
    resetField,
    watch,
    formState: { errors },
  } = useFormContext<ISchedulingFields>();

  const chosenStartDate = watch("startDate");

  useEffect(() => {
    resetField("shiftId");
  }, [chosenStartDate, resetField]);

  const quickSelections: IQuickSelection[] = [
    { label: t`2 dagar sedan`, date: subDays(new Date(), 2) },
    { label: t`Igår`, date: subDays(new Date(), 1) },
    { label: t`Idag`, date: new Date() },
  ];

  return (
    <>
      <Form.Section>
        <Form.Row type="flex">
          <DateInput
            hasEndDate={false}
            quickSelections={quickSelections}
            minDate={new Date("1900-01-01")}
          />
          <InputField
            label={t`Tid`}
            showOptionalLabel={false}
            errorMessage={errors.time?.message}
            type="time"
            {...register("time", {
              required: {
                value: true,
                message: t`Ange tid`,
              },
              pattern: {
                value: /^\d{1,2}:\d{2}$/,
                message: t`Tid anges på formatet HH:mm`,
              },
            })}
          />
        </Form.Row>
      </Form.Section>
      {chosenStartDate ? (
        <ShiftPicker
          excludeUnassignedShifts={false}
          date={calendarDateSchema.decode(chosenStartDate)}
        />
      ) : null}
    </>
  );
};
